module.exports = __webpack_public_path__ + "static/media/YB5F10_0.228fd8fd.jpg";